import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (typeof window === "undefined") return () => {};
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
        cancelAnimationFrame(rafId);
        if (lenis) lenis.destroy();
        lenis = null;
    };
}

export function scrollTop() {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
}

export function scrollToHash(hash) {
    const el = document.getElementById(hash.replace("#", ""));
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -110 });
    else el.scrollIntoView();
}
